import axios from "axios";
import Config from "@/config"

export default class RecipeService {
    getSingleRecipe(accesstoken, id) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: {
                "populate[media][fields]": "url",
                "populate[category][fields]": "key",
                "populate[ingredients][populate][ingredient][populate][labels][fields]": "key,value,locale",
                "populate": "labels",
                "populate[ingredients][populate][unit][populate][labels][fields]": "key,value,locale"
            }
        };
        return axios
            .get(
                Config.proxy + Config.url("recipe") + "/" + id,
                options
            )
            .then(res => {
                res.data.data.attributes.id = id;
                return res.data.data.attributes;
            })
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    getRecipes(accesstoken, params = {}){
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: params
        };
        return axios
            .get(
                Config.proxy + Config.url("recipe"),
                options
            )
            .then(res => {
                return res.data
            })
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    getLikedRecipesbyUser(accesstoken,id) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: {
                "populate[liked_recipes][fields]": "key",
                "fields": "id"
            }
        };
        return axios
            .get(
                Config.proxy + Config.url("user")+"/"+id,
                options
            )
            .then(res => res.data.liked_recipes)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    getCategories(accesstoken,params = {}) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: params
        };
        return axios
            .get(
                Config.proxy + Config.url("categories"),
                options
            )
            .then(res => res.data.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    getCategoryTranslation(accesstoken,params = {}) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: params
        };
        return axios
            .get(
                Config.proxy + Config.url("categories"),
                options
            )
            .then(res => res.data.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
}
